import { COLOR_STROKE } from '../colors.constants';

export const colorsDivider = {
  colorsDividerBorder: COLOR_STROKE,
};
